import styled from 'styled-components';

const ProgressBars = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  margin: 3rem auto;
`;

export default ProgressBars;
